<div slot="end" class="custom-switch custom-switch-label-yesno">
  <input
    class="custom-switch-input"
    [id]="toggleId"
    type="checkbox"
    [(ngModel)]="checked"
    (change)="onChange()"
  />
  <label class="custom-switch-btn" [for]="toggleId"></label>
</div>
